<template>
  <div ref="sticky" class="sticky-counter-number" :style="style">
    <p
      :style="{ transform: showCurrentActiveItemNumber }"
      v-for="(item, index) in content"
      :key="index"
    >{{ formatedText(index) }}</p>
  </div>
</template>

<script>
import Sticky from './../mixins/sticky'

export default {
  name: "StickyCounter",
  mixins: [ Sticky ],
  props: {
    content: Array,
    currentActiveItem: Number,
    activatePercentsFromTop: Number
  },
  data() {
    return {
      translateStyleString: `translateY(${0}px)`,
    };
  },
  computed: {
    showCurrentActiveItemNumber() {
      return `translateY(${this.currentActiveItem * -100}%)`
    },
  },

  methods: {
    formatedText(index) {
      return `0${index + 1}.`;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.sticky-counter-number {
  @include typeset(display-1);
  @extend %page-margin-3;
  // @extend %title-margin-3;

  height: 1em;
  overflow: hidden;

  p {
    @include typeface(expanded);
    @extend %non-selectable;

    transition: transform 0.2s;

    font-variant-numeric: tabular-nums;
    font-size: 1em;
    line-height: 1;
  }
}
</style>
